"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Debugger = /** @class */ (function () {
    function Debugger() {
    }
    Debugger.loaded = function (message) {
        this.info("Loaded Component: " + message);
    };
    Debugger.depreciated = function (source, message) {
        if (message === void 0) { message = null; }
        var styles = [
            "background: linear-gradient(#D33106, #571402)",
            "border: 1px solid #3E0E02",
            "width: 100%",
            "color: white",
            "display: block",
            "text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)",
            "box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255, 255, 255, 0.4) inset",
            "line-height: 40px",
            "text-align: center",
            "font-weight: bold"
        ].join(";");
        // tslint:disable-next-line:no-console
        console.error("%cDEPRECIATED WARNING: " + source + " is depreciated. [" + message + "]", styles);
    };
    Debugger.info = function (message) {
        this.write("INFO", message, "#3dccc0");
    };
    Debugger.warn = function (message) {
        this.write("WARNING", message, "#ccc228");
    };
    Debugger.error = function (message) {
        this.write("Error", message, "#cc2b35");
    };
    Debugger.write = function (type, message, color, bgcolor) {
        if (bgcolor === void 0) { bgcolor = "#ffffff"; }
        // tslint:disable-next-line:no-console
        console.log("%c[" + Date() + "] %c" + type + ": %c" + message, "background-color:" + bgcolor, "color:" + color + ";background-color:" + bgcolor, "color:#000000;background-color:" + bgcolor);
    };
    return Debugger;
}());
exports.default = Debugger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvRGVidWdnZXIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTtJQUFBO0lBa0RBLENBQUM7SUFqRGUsZUFBTSxHQUFwQixVQUFxQixPQUFlO1FBQ2xDLElBQUksQ0FBQyxJQUFJLENBQUMsdUJBQXFCLE9BQVMsQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFFYSxvQkFBVyxHQUF6QixVQUEwQixNQUFjLEVBQUUsT0FBNkI7UUFBN0Isd0JBQUEsRUFBQSxjQUE2QjtRQUNyRSxJQUFNLE1BQU0sR0FBVztZQUNyQiwrQ0FBK0M7WUFDL0MsMkJBQTJCO1lBQzNCLGFBQWE7WUFDYixjQUFjO1lBQ2QsZ0JBQWdCO1lBQ2hCLHlDQUF5QztZQUN6Qyx5SUFBeUk7WUFDekksbUJBQW1CO1lBQ25CLG9CQUFvQjtZQUNwQixtQkFBbUI7U0FDcEIsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDWixzQ0FBc0M7UUFDdEMsT0FBTyxDQUFDLEtBQUssQ0FDWCw0QkFBMEIsTUFBTSwwQkFBcUIsT0FBTyxNQUFHLEVBQy9ELE1BQU0sQ0FDUCxDQUFDO0lBQ0osQ0FBQztJQUNhLGFBQUksR0FBbEIsVUFBbUIsT0FBZTtRQUNoQyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDekMsQ0FBQztJQUVhLGFBQUksR0FBbEIsVUFBbUIsT0FBZTtRQUNoQyxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsRUFBRSxPQUFPLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVhLGNBQUssR0FBbkIsVUFBb0IsT0FBZTtRQUNqQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVnQixjQUFLLEdBQXRCLFVBQ0UsSUFBWSxFQUNaLE9BQWUsRUFDZixLQUFhLEVBQ2IsT0FBMkI7UUFBM0Isd0JBQUEsRUFBQSxtQkFBMkI7UUFFM0Isc0NBQXNDO1FBQ3RDLE9BQU8sQ0FBQyxHQUFHLENBQ1QsUUFBTSxJQUFJLEVBQUUsWUFBTyxJQUFJLFlBQU8sT0FBUyxFQUN2QyxzQkFBb0IsT0FBUyxFQUM3QixXQUFTLEtBQUssMEJBQXFCLE9BQVMsRUFDNUMsb0NBQWtDLE9BQVMsQ0FDNUMsQ0FBQztJQUNKLENBQUM7SUFDSCxlQUFDO0FBQUQsQ0FBQyxBQWxERCxJQWtEQyJ9